export default __webpack_public_path__ + "static/media/cross_menu_icon.469e6c2f.svg";